import { axiosGetHandler, axiosPostHandler } from './config';
import { extractAPIValues } from '_lib/utils/utils';
const { BASE_XHH, BASE_API } = extractAPIValues();

/**
 * 获取上次组队配置
 * @see https://app.apifox.com/link/project/6486200/apis/api-379599210
 * @param {object} args 请求参数
 * @returns {Promise<object>}
 */
export function getLastTeamConfig(args) {
  let url = BASE_XHH + '/team/config';
  return axiosGetHandler(url, args);
}

/**
 * 填写组队信息发起组队
 * @see https://app.apifox.com/link/project/6486200/apis/api-379607431
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据（游戏绑定KV，如平台、模式等动态字段）
 * @returns {Promise<object>}
 */
export function createGlobalTeam(args, formdata) {
  let url = BASE_XHH + '/team/create';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 修改组队信息
 * @see https://app.apifox.com/link/project/6486200/apis/api-379622687
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function updateGlobalTeam(args, formdata) {
  let url = BASE_XHH + '/team/update';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 踢出成员
 * @see https://app.apifox.com/link/project/6486200/apis/api-379623958
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function kickOutGlobalTeamMember(args, formdata) {
  let url = BASE_XHH + '/team/kickout';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 通过组队大厅/语音频道加入队伍
 * @see https://app.apifox.com/link/project/6486200/apis/api-379631083
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function joinGlobalTeam(args, formdata) {
  let url = BASE_XHH + '/team/join';
  return axiosPostHandler(url, args, formdata);
}

let getGlobalTeamInfoPromise = null;
/**
 * 获取队伍信息
 * @see https://app.apifox.com/link/project/6486200/apis/api-379633315
 * @param {object} args 请求参数
 * @returns {Promise<object>}
 */
export function getGlobalTeamInfo(args) {
  if (getGlobalTeamInfoPromise) {
    return getGlobalTeamInfoPromise;
  }
  let url = BASE_XHH + '/team';
  getGlobalTeamInfoPromise = axiosGetHandler(url, args).finally(() => {
    getGlobalTeamInfoPromise = null;
  });
  return getGlobalTeamInfoPromise;
}

/**
 * 获取组队历史记录
 * @see https://app.apifox.com/link/project/6486200/apis/api-379655556
 * @param {object} args 请求参数
 * @returns {Promise<object>}
 */
export function getGlobalTeamHistory(args) {
  let url = BASE_XHH + '/team/history';
  return axiosGetHandler(url, args);
}

/**
 * 获取队伍列表
 * @see https://app.apifox.com/link/project/6486200/apis/api-379777254
 * @param {object} args 请求参数
 * @returns {Promise<object>}
 */
export function getGlobalTeamList(args) {
  let url = BASE_XHH + '/team/list';
  return axiosGetHandler(url, args);
}

/**
 * 离开队伍
 * @see https://app.apifox.com/link/project/6486200/apis/api-379777395
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function leaveGlobalTeam(args, formdata) {
  let url = BASE_XHH + '/team/leave';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 发起语音
 * IF 已经绑定频道ID: 进入语音频道
 * ELSE 分配空闲频道并加入
 * @see https://app.apifox.com/link/project/6486200/apis/api-379777626
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function voiceInviteToGlobalTeam(args, formdata) {
  let url = BASE_XHH + '/team/voice_invite';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 发送队伍消息
 * 参数与群聊/频道的send一致，用team_id替代channel_id/chat_group_id
 * @see https://app.apifox.com/link/project/6486200/apis/api-379778031
 * @param {object} args 请求参数
 * @param {object} formdata 表单数据
 * @returns {Promise<object>}
 */
export function sendGlobalTeamMessage(args, formdata) {
  let url = BASE_XHH + '/team/messages/send';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 删除队伍历史消息
 * @see https://app.apifox.com/link/project/6486200/apis/api-381071690
 * @param {*} args
 * @param {*} formdata
 * @returns
 */
export function deleteGlobalTeamHistory(args, formdata) {
  let url = BASE_XHH + '/team/history/delete';
  return axiosPostHandler(url, args, formdata);
}

/**
 * 获取发布组队配置
 * @see https://app.apifox.com/link/project/6486200/apis/api-382398501
 * @param {*} args
 * @returns
 */
export function getPublishGlobalTeamConfig(args) {
  let url = BASE_XHH + '/team/game_tags';
  return axiosGetHandler(url, args);
}

/**
 * 编辑全局组队设置
 * @param {*} args
 * @param {*} formdata
 * @returns
 */
export function editGlobalTeamSetting(args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/team_bind/global_team_setting';
  return axiosPostHandler(url, args, formdata);
}
